function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, $hooks, JSON, Object, keydownProxyEl, tooltipData) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": {
          'child-menu-items-menu': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-items-menu", {
          "attrs": __vjadeStringifyAttrsIfObj({
            'empty-message': `No items found`,
            'multiple': $attr(`multiple`),
            'search-filter': $helpers.getSearchFilter(),
            'sections': $helpers.getMenuSections(),
          }),
          "hook": {
            insert: $helpers.handleItemsMenuInsert,
          },
          "on": {
            click: ev => ev.stopPropagation(),
            clickItem: $helpers.handleItemClick,
            focusItem: $helpers.showItemDetails,
          },
          "props": {
            keydownProxyEl,
            sectionsFromInputFn: $helpers.sectionsFromInput,
            customSearchMatcherFn: $helpers.customSearchMatcherFn,
          },
        }));
        __jade_nodes = __jade_nodes.concat(($attr(`open`) && tooltipData) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-context-panel", {
            "hook": {
              remove: $hooks.delayedAttrRemove(`tooltip-data`, null)
            },
            "attrs": __vjadeStringifyAttrsIfObj({
              'tooltip-data': tooltipData,
              'position-parent-selector': `mp-drop-menu`,
            }),
            "on": {
              tooltipContextAction: $helpers.propagateEvent,
              tooltipContextEditDescription: $helpers.propagateEvent,
            },
          }));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "$hooks" in locals ? locals.$hooks : typeof $hooks !== "undefined" ? $hooks : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "keydownProxyEl" in locals ? locals.keydownProxyEl : typeof keydownProxyEl !== "undefined" ? keydownProxyEl : undefined, "tooltipData" in locals ? locals.tooltipData : typeof tooltipData !== "undefined" ? tooltipData : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;